import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import './index.css';
import ManageSurveys from './Pages/ManageSurveys';
import CompleteSurvey from './Pages/CompleteSurvey';
import CreateSurvey from './Pages/CreateSurvey';
import NavBar from './Components/NavBar';
import Footer from './Components/Footer';
import useAuth from './CustomHooks/useAuth';
import SurveyResults from './Pages/SurveyResults';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
  typography: {
    fontFamily: 'font-BCBold, Arial, sans-serif', // Add your custom font here
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            fontFamily: 'font-BCBold', // Apply custom font to focused InputLabel
            color: '#475569',
            fontSize: '1rem',
          },
        },
      },
    },
  },
});

function App() {

  useAuth();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className='flex flex-col bg-[#1b1a1a] min-h-screen'>
        <div className='pb-10'>
        <Router>
          <NavBar />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/survey-builder' element={<CreateSurvey />} />
            <Route path='/manage-surveys' element={<ManageSurveys />} />
            <Route path='/complete-survey' element={<CompleteSurvey />} />
            <Route path='/complete-survey/:id' element={<CompleteSurvey />} />
            <Route path='/analyze-results/:id' element={<SurveyResults />} />
          </Routes>
        </Router>
        </div>
        {/* <div className='flex-grow flex flex-col justify-end'> */}
          <Footer />
        {/* </div> */}
      </div>
    </ThemeProvider>
  );
}

export default App;
